import { render, staticRenderFns } from "./ratioModal.vue?vue&type=template&id=62135d9c&scoped=true"
import script from "./ratioModal.vue?vue&type=script&lang=js"
export * from "./ratioModal.vue?vue&type=script&lang=js"
import style0 from "./ratioModal.vue?vue&type=style&index=0&id=62135d9c&prod&lang=scss&scoped=true"
import style1 from "./ratioModal.vue?vue&type=style&index=1&id=62135d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62135d9c",
  null
  
)

export default component.exports